let search_field = {
  wd: "模糊搜索",
  member_id: "客户编号",
  name: "姓名",
  source_id: "来源",
  level: "等级",
  qq: "QQ",
  wechat_id: "微信号",
  mobile: "手机号码",
  point_gte: "积分大于",
  point_lte: "积分小于",
  expense_gte: "总消费大于",
  expense_lte: "总消费大于",
  user_id: "客服"
};
const {
  CancelToken,
  isCanCel
} = axios;
const source = CancelToken.source();
export default {
  data() {
    return {
      search_user_ids: [],
      search_level: [],
      search_identity: [],
      search_demand_type: [],
      search_source_id: undefined,
      search_promote_source_id: undefined,
      search_member_type: undefined,
      search_trademark_types: [],
      identity_array: ["seller", "buyer", "both"],
      search_field: search_field,
      created_updated: "created",
      sort_field_columns: [{
        name: "录入时间",
        value: "created_at"
      },
        {
          name: "修改时间",
          value: "updated_at"
        },
        {
          name: "客户等级",
          value: "level"
        },
        {
          name: "账户余额",
          value: "balance_frozen"
        },
        {
          name: "账户总结金额",
          value: "balance"
        },
        {
          name: "总消费金额",
          value: "amount_consume"
        }
      ],
      sort_field: "created_at",
      sort_field_text: "创建时间",
      sort_dir: "desc",
      visible_export: false,
      exportting: false,
      export_scope: null,
      export_date: [
        moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD")
      ]
    };
  },
  watch: {
    $route() {
      this.reset_query();
    }
  },
  created() {
    this.reset_query();

    this.load_stat();
  },
  methods: {
    load_stat() {
      this.$http.get(`/member/stat`).then((res) => {
        if (res.success) {
          this.$store.commit("change_state", {
            name: "stat_member",
            value: res.data
          });
        }
      });
    },
    load_tags() {
      this.loading_folder = true;
      //TODO:不重复获取

      this.$http
        .get("member/tags")
        .then((response) => {
          if (response.success) {
            this.$store.commit("change_state", {
              name: "member_sidebar_tags",
              value: response.data
            });

            //sub_title
            this.menu_subtitle();
          }
        })
        .catch(() => {
        })
        .then(() => {
          this.loading_folder = false;
        });
    },
    reset_query() {
      let query = this.$route.query;

      this.wd = "wd" in query ? query["wd"] : "";

      this.search_level = Object.prototype.hasOwnProperty.call(query, "level") ? query["level"].split(",") : [];
      this.level = "level" in query ? query["level"] : "";

      //身份
      this.search_identity = "identity" in query ? query["identity"].split(",") : [];

      //客服
      this.search_user_ids = "user_id" in query ? query["user_id"].split(",") : [];

      //客户需求
      this.search_demand_type = "demand_type" in query ? query["demand_type"].split(",") : [];

      //来源
      this.search_source_id = "source_id" in query ? query["source_id"] : undefined;
      this.search_promote_source_id = "promote_source_id" in query ? query["promote_source_id"] : undefined;

      //客户类型
      this.search_member_type = "member_type" in query ? query["member_type"] : undefined;

      //商标类型
      this.search_trademark_types = "trademark_types" in query ? query["trademark_types"].split(",") : [];

      if (Object.prototype.hasOwnProperty.call(query, "sort_field")) {
        this.sort_field = query["sort_field"];
        let index = this.sort_field_columns.findIndex((v) => v.value == this.sort_field);
        if (index > -1) {
          this.sort_field_text = this.sort_field_columns[index]["name"];
        }
      }
      if (Object.prototype.hasOwnProperty.call(query, "sort_dir")) {
        this.sort_dir = query["sort_dir"];
      }
    },
    on_create() {
      this.$store.commit("change_member_create_visible", true);
      this.$store.commit("change_customer_create_callback", this.load);
    },
    on_show(record) {
      this.$store.commit("change_member_record", record);
      this.$store.commit("change_member_visible", true);
      this.$store.commit("change_customer_callback", this.load);
    },
    custom_row(record) {
      return {
        on: {
          dblclick: (event) => {
            this.on_show(record);
          }
        }
      };
    },
    on_move_tags(item) {
      this.$event_bus.$emit("visible_member_tags_list", item, () => {
        this.load_tags();
        this.load();
        this.selected_row_keys = [];
      });
    },
    on_export(scope) {
      this.visible_export = true;
      this.export_scope = scope;
    },
    on_reset_password(record) {
      this.visible_resetpwd = true;
      this.selected_record = record;
    },
    on_delete(record, force = false) {
      this.$confirm({
        centered: true,
        title: `是否要删除【${record.name}】`,
        content: `${force ? "请注意，执行删除后将无法无法恢复。" : "该客户将会进入【已删除】标签。"}`,
        onOk: () => {
          return new Promise((resolve, reject) => {
            this.$http
              .delete(force ? `member/force/${record.id}` : `member/${record.id}`)
              .then((res) => {
                if (res.success) {
                  this.load();
                } else {
                  this.$error({
                    title: "失败",
                    content: res.message
                  });
                }
              })
              .catch(() => {
              })
              .then(() => {
                resolve();
              });
          });
        }
      });
    },
    on_export_default(scope) {
      this.$confirm({
        centered: true,
        title: "导出确认",
        content: `是否需要导出所有客户数据？${this.pagination.total >= 10000 ? "（当前数据较多，导出时间可能较长，期间请勿刷新或者关闭页面）" : ""
        }`,
        loading: true,
        onOk: () => {
          return new Promise((resolve, reject) => {
            this.$http
              .post(
                `/customer/export`, {
                  scope: scope
                }, {
                  cancelToken: source.token
                }
              )
              .then((res) => {
                if (res.success) {
                  this.$message.success(res.message);
                  window.location.href = res.data.url;
                } else {
                  this.$error({
                    title: "失败",
                    content: res.message
                  });
                }
              })
              .catch(() => {
              })
              .then(() => {
                resolve();
              });
          }).catch();
        },
        onCancel: () => {
          source.cancel("cancel");
        }
      });
    },
    on_export_submit() {
      this.exportting = true;
      const dateBegin = this.export_date[0] + " 00:00:00";
      const dateEnd = this.export_date[1] + " 23:59:59";

      const exportWindow = window.open('', '_blank');

      this.$http
        .post(
          `/member/export?date_begin=${dateBegin}&date_end=${dateEnd}`, {}, {
            cancelToken: source.token
          }
        )
        .then((res) => {
          if (res.success) {
            this.visible_export = false;
            this.$message.success(res.message);
            exportWindow.location.href = res.data.url;
          } else {
            this.$error({
              title: "失败",
              content: res.message
            });
          }
        })
        .catch(() => {
        })
        .then(() => {
          this.exportting = false;
        });
    },
    on_dir_change() {
      let new_query = JSON.parse(JSON.stringify(this.$route.query));
      new_query["sort_dir"] = this.sort_dir === "asc" ? "desc" : "asc";

      this.$router.push(this.path + "?" + this.objectToQuery(new_query));
    },
    on_sort_change(e) {
      let new_query = JSON.parse(JSON.stringify(this.$route.query));
      new_query["sort_field"] = e;

      this.$router.push(this.path + "?" + this.objectToQuery(new_query));
    },
    on_distribute(item) {
      let user_id = item.length === 1 ? item[0].user_id : null;
      let callback = () => {
        this.load();
        this.selected_row_keys = [];
      };
      this.$event_bus.$emit("visible_customer_distribute", item, user_id, callback);
    },
    on_login_user(record) {
      this.$confirm({
        centered: true,
        title: `提醒`,
        content: `是否要登录【${record.name}】的用户端？`,
        onOk: () => {
          return new Promise((resolve, reject) => {
            var myWindow = window.open("");

            this.$http
              .post("member/login_assistant", {
                member_id: record.id
              })
              .then((res) => {
                if (res.success) {
                  myWindow.location = res.data.url;
                  myWindow.focus();
                } else {
                  myWindow.close();
                  this.$error({
                    title: "失败",
                    content: res.message
                  });
                }
              })
              .catch(() => {
              })
              .then(() => {
                resolve();
              });
          });
        }
      });
    }
  }
};
